import { render, staticRenderFns } from "./TreeSelectOption.vue?vue&type=template&id=f10300aa&scoped=true"
import script from "./TreeSelectOption.vue?vue&type=script&lang=js"
export * from "./TreeSelectOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10300aa",
  null
  
)

export default component.exports